import React from 'react';
import classnames from 'classnames';
import styles from '../editContactModal.module.scss';
import { ContactFormProps } from 'v2/models';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import RichTextEditor from 'v2/form/RichTextEditor/RichTextEditor';

const ContactDescriptionForm = ({ setValue, contact }: ContactFormProps) => {
  return (
    <div className={classnames(styles.descriptionForm)}>
      <FormLabel label={`Contact Description`} required={false} />
      <div>
        <RichTextEditor
          readOnly={false}
          aria-label="contact-description-input"
          value={contact?.description || ''}
          autoFocus
          onChange={(data) =>
            setValue?.('description', data, {
              shouldValidate: true,
              shouldDirty: true,
            })
          }
        />
      </div>
    </div>
  );
};

export default ContactDescriptionForm;
